import { useQuery } from "react-query";

import { useCombinationRules } from "./useCombinationRules";
import { COMBINATION_RULES_QUERY_KEY } from "./useGetCombinationRules";

export const useGetCombinationRuleById = (
  id: number | string,
  enabled = true,
) => {
  const { ruleGetById } = useCombinationRules();

  const { data, isLoading, isError } = useQuery({
    queryKey: [COMBINATION_RULES_QUERY_KEY, "byId", String(id)],
    queryFn: () => ruleGetById(id),
    enabled: enabled && !!id,
  });

  return {
    rule: data?.data,
    isLoading,
    isError,
  };
};
